import { get } from '../utils/FetchV2.util';
import type { UserTag } from '@/@types/Tagging.type';

export const getUserTagsService = (): Promise<UserTag[]> =>
	get({ service: 'tagging', endpoint: '/taggings/user' });
